module.exports = __webpack_public_path__ + "static/logo_full-0478d0be4a5d4752f53ac4276963cc17.png";